export default {
  token: localStorage.getItem('token') || "",
  loginFailed: false,
  authUser: {},
  listKeyAuthUser: [],
  emailReset: "",
  timer: 0,
}